import { useCallback, useMemo } from 'react';
import { FJFailedPageAction } from '../../redux/action/FJFailedPageAction';
import { FJ_COMMON_VIEW } from '../../redux/slice/FJCommonSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import FJLongToShortStore from '../../store/FJLongToShortStore';
import FJFailedPage from './FJFailedPage';
import useLocalStore from '@src/hooks/useLocalStore';

export default function FJFailedPageContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const visible = useAppSelector(state => state.common.activeView === FJ_COMMON_VIEW.FAILED);
    const projectItems = useAppSelector(state => state.startLanding.projects.items);

    const failedErrorCode = useMemo(() => {
        const fromStore = FJLongToShortStore.getCurFailedErrorCode();
        if (fromStore) {
            return fromStore;
        }
        const eventId = FJLongToShortStore.getCurFailedTaskId();
        if (!eventId) {
            return undefined;
        }
        return projectItems.find(i => i.eventId === eventId)?.errorCode;
        /* eslint-disable-next-line */
    }, [visible, projectItems]);

    const isHighlightExtractionFailure = FJLongToShortStore.isHighlightExtractionFailure(failedErrorCode);

    const handleTryAgain = useCallback(() => {
        dispatch(FJFailedPageAction.hideFailedPageTryAgainAction());
    }, [dispatch]);

    const handleBack = useCallback(() => {
        dispatch(FJFailedPageAction.hideFailedPageBackAction());
    }, [dispatch]);

    if (!visible) {
        return null;
    }

    return (
        <FJFailedPage
            onTryAgain={handleTryAgain}
            onBack={handleBack}
            showTryAgain={!isHighlightExtractionFailure}
            titleKey={isHighlightExtractionFailure ? 'highlight-extraction-failed' : 'video-generation-failed'}
            descKey={
                isHighlightExtractionFailure
                    ? 'highlight-extraction-failed-desc'
                    : 'this-task-failed-due-to-network-fluctuations-or-service-overload-please-try-again-later'
            }
        />
    );
}
